module.exports = __webpack_public_path__ + "img/contact.bfe2bbdf.jpg";